module.exports = __webpack_public_path__ + "static/media/Page05.b486977c.png";